import { Tooltip } from "antd";

/* eslint-disable react/prop-types */
const DashboardTooltip = ({
  text,
  children,
  maxLength = 25,
  fallback = "N/A",
  placement = "topLeft",
  className = "",
  alwaysShow = false,
}) => {
  const rawContent = text ?? (typeof children === "string" ? children : "");
  const content =
    rawContent !== null && rawContent !== undefined
      ? String(rawContent).trim()
      : "";

  if (!content) return fallback;

  if (alwaysShow || content.length > maxLength) {
    return (
      <Tooltip
        title={content}
        placement={placement}
        color="#8B2433"
        trigger={["hover", "click"]}
        styles={{
          body: {
            borderRadius: "10px",
            padding: "8px 14px",
            fontSize: "12px",
            fontWeight: 500,
            letterSpacing: "0.015em",
            lineHeight: 1.4,
            boxShadow:
              "0 8px 24px rgba(139, 36, 51, 0.35), 0 2px 6px rgba(0, 0, 0, 0.08)",
          },
        }}
      >
        <span className={`cursor-pointer block truncate ${className}`}>
          {content.length > maxLength ? `${content.slice(0, maxLength)}...` : content}
        </span>
      </Tooltip>
    );
  }

  return className ? <span className={className}>{content}</span> : content;
};

export default DashboardTooltip;

